import React, {Component} from 'react';
import {getInspectionHistory} from '../../data/inspection_api';
import {PROPERTY_API_URL} from "../../constants/api_routes";
import ReactTable from "react-table";
import Loader from "../universal/loader";
import moment from "moment";
import {Button, Icon} from "semantic-ui-react";
import FilterAttributes from "../../containers/filter_container";
import {withRouter} from "react-router-dom";

class InspectionHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            propertyDetails: undefined,
            inspectionIds: [],
        }
    }

    getHistory = async () => {
        if (this.props.propertyId) {
            const response_ = await getInspectionHistory(PROPERTY_API_URL, this.props.propertyId);
            let response = response_.inspections || []
            this.setState({propertyDetails: response});
            const len = response.length;
            let insIds = [];
            for (let i = 0; i < len; i++) {
                insIds[i] = response[i]["id"];
            }
            this.setState({inspectionIds: insIds});
        }
    };

    componentWillMount() {
        this.getHistory().then(() => {
        });
    }

    render() {
        const columns = [
            {
                Header: 'Ref No',
                accessor: 'reference_id',
                filterable: true
            },
            {
                Header: 'Company',
                accessor: 'company_name',
                filterable: true
            }, {
                Header: 'Inspection Date',
                id: 'inspection_date',
                accessor: d => moment(d['inspection_time']['inspection_date'], "YYYY-MM-DD").format("DD-MM-YYYY"),
                filterable: true
            }, {
                Header: 'Job type',
                accessor: 'inspection_type',
                id: 'inspection_type',
                className: 'formatcase mini-width',
                headerClassName: 'mini-width dropdown-overlay',
                filterable: true,
                filterMethod: (filter, row) => {
                    if (filter.value === "ci") {
                        return row[filter.id] === 'ci';
                    }
                    if (filter.value === "co") {
                        return row[filter.id] === 'co';
                    }
                    if (filter.value === "inv") {
                        return row[filter.id] === 'inv';
                    }
                    if (filter.value === "inv/ci") {
                        return row[filter.id] === 'inv/ci';
                    }
                    return true;
                },
                Filter: ({filter, onChange}) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{width: "100%"}}
                        value={filter ? filter.value : "all"}
                    >
                        <option value="true">Show all</option>
                        <option value="ci">CI</option>
                        <option value="co">CO</option>
                        <option value="inv">INV</option>
                        <option value="inv/ci">INV/CI</option>
                    </select>
            },
            {
                Header: 'Assigned To',
                id: 'user',
                accessor: d => d.user ? d.user['name'] : "unassigned",
                Cell: ({original, value}) => (
                    <div>
                        {original.user ? <span>{value}</span> : <span className="status-red">Un Assigned</span>}
                    </div>
                ),
                filterable: true
            }, {
                Header: 'Size',
                id: 'propsize',
                headerClassName: 'micro-width',
                className: 'micro-width',
                accessor: d => d['property_size'],
                filterable: true
            }, {
                Header: 'Property Type',
                id: 'proptype',
                accessor: d => d.property['furnishing_type'],
                className: 'format-capitalize',
                filterable: true
            }, {
                Header: 'Report Type',
                id: 'reptype',
                accessor: d => d['report_type'],
                className: 'format-capitalize',
                filterable: true
            },  {
                Header: 'Action',
                id: 'view',
                accessor: 'id',
                className: 'table-actions',
                headerClassName: 'table-actions',
                sortable: false,
                Cell: ({original, value}) => (
                    <div>
                        <Button basic compact icon positive size='mini' onClick={() => {
                            this.props.setFilter(undefined, undefined, undefined, this.state.inspectionIds);
                            this.props.history.push('/inspection')
                        }}><Icon
                            name='eye'/>View</Button>
                    </div>
                )
            },

        ];

        return (<div className="center-aligned">
            {!this.state.propertyDetails && <Loader contain/>}
            {this.state.propertyDetails && <ReactTable
                data={this.state.propertyDetails}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                defaultPageSize={10}
                minRows={0}
            />}
        </div>);
    }

}

export default FilterAttributes(withRouter(InspectionHistory));


// WEBPACK FOOTER //
// ./src/views/properties/inspection_history.js